import {useEffect} from 'react'
import {Link as RouterLink} from 'react-router-dom'

import AppsIcon from '@mui/icons-material/Apps'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import Link from '@mui/material/Link'
import SettingsIcon from '@mui/icons-material/Settings'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import Loader from '../../shared/Loader'

import {APPLICATIONS, SETTINGS} from '../../../state/actionTypes'
import {connect} from '../../../state/hooks/tools'
import {isEmpty} from '../../../lib/tools'
import {formatDate} from '../../../lib/data'
import {readEndpoint} from '../../../lib/asyncMethods'

const ApplicationsController = props => {
  useEffect(() => {
    if (isEmpty(props.applications))
      props.readEndpoint('metadata/applications')
    if (isEmpty(props.settings))
      props.fetchSettings('settings')
  }, [])

  return (
    <Loader loading={isEmpty(props.applications)}>
      <Stack className='applications-controller' sx={{width: '60%'}}>
        <Stack className='label' direction='row'>
          <AppsIcon fontSize='large' />
          <Typography variant='h5'>Applications</Typography>
        </Stack>
        <Divider />
        <Grid container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}} sx={{marginTop: '15px'}}>
          {
            props.applications?.map(application => (
              <Grid key={application.id} size={6}>
                <Card sx={{bgcolor: 'Background'}}>
                  <CardContent>
                    <Typography variant='body1'>Name: {application.name}</Typography>
                    <Typography variant='body1'>Created At: {formatDate(application.createdAt)}</Typography>
                  </CardContent>
                  <CardActions>
                    <Link component={RouterLink} to={`${application.id}/versions`}>
                      <IconButton aria-label='versions' color='success'>
                        <SettingsIcon />
                      </IconButton>
                    </Link>
                  </CardActions>
                </Card>
              </Grid>
            ))
          }
        </Grid>
      </Stack>
    </Loader>
  )
}

const mapStateToProps = ({metadata}) => ({...metadata})

const actionCreators = ({metadata}) => ({readEndpoint: readEndpoint(metadata, APPLICATIONS), fetchSettings: readEndpoint(metadata, SETTINGS)})

export default connect(mapStateToProps, actionCreators)(ApplicationsController)
